import { useContext } from 'react';

import { TooltipContext, type TooltipContextType } from '@visx/xychart';

export const useCursor = <TData extends object>() => {
  const visxTooltipContext = useContext<TooltipContextType<TData> | null>(TooltipContext);
  return {
    data: visxTooltipContext?.tooltipData?.nearestDatum?.datum,
    index: visxTooltipContext?.tooltipData?.nearestDatum?.index,
    nearestKey: visxTooltipContext?.tooltipData?.nearestDatum?.key,
    showCursor: visxTooltipContext?.showTooltip,
    hideCursor: visxTooltipContext?.hideTooltip,
    updateCursor: visxTooltipContext?.updateTooltip,
  };
};
